// extracted by mini-css-extract-plugin
module.exports = {"container":"_1e27269","item":"_54d6c52","singleDetails":"_6102dbf","singleDetailsDate":"_4095b99","marketIcon":"_ef84d5e","selection":"_b19817d"};